// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import storeChurnImage from '../../../../assets/img/store-churn-img.svg';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {Grid, Typography} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';
import {connect} from 'react-redux';

import type {User} from '../../../../entities';
import type {RootState} from '../../../index';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
  }),
  null
)(StoreChurnModal);

type Props = {|
  user?: User,
  open: boolean,
  handleClose: () => void,
|};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 360,
    maxWidth: '100%',
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      width: 600,
    },
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    marginTop: theme.spacing(1),
    '& span': {
      color: colors.purple,
    },
  },
  subtitle: {
    margin: theme.spacing(1.5, 0),
    color: colors.grey900,
    fontSize: 14,
    fontWeight: 400,
  },
  text: {
    marginTop: theme.spacing(3),
    color: colors.grey800,
    fontSize: '1.125rem',
  },
  bold: {fontWeight: 600},
  button: {
    height: 48,
    // borderRadius: '8px',
    marginTop: theme.spacing(2),
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: '4px 80px',
    maxWidth: '100%',
  },
  mainContent: {
    width: '100%',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: theme.spacing(3, 0),
  },
  mainImg: {
    maxWidth: '100%',
  },
  wrapTitle: {
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(5),
    },
  },
}));

function StoreChurnModal(props: Props) {
  const {open, handleClose, user} = props;
  const classes = useStyles();

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <div className={classes.wrapTitle}>
              <Typography className={classes.title} align="center">
                <span>{user ? user.firstName : ''}</span>
                {user && <br />}
                Suscríbete a uno de <br /> nuestros planes
              </Typography>
              <Typography className={classes.subtitle}>
                Y gestiona tu negocio con TiendaDa.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className={classes.mainContent}>
              <img className={classes.mainImg} src={storeChurnImage} alt="" />
            </div>
          </Grid>
        </Grid>
        <CustomButton
          variant="contained"
          component={Link}
          onClick={handleClose}
          className={classes.button}
          to="/tiers-list"
        >
          Elegir plan
        </CustomButton>
      </div>
    </CustomModal>
  );
}

StoreChurnModal.propTypes = {
  user: PropTypes.object,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
